export class ClienteInternacionalFilter {
   emisorId: string;
   razonSocial: string;
   nombreFantasia: string;
   direccionCalle: string;
   direccionNumero: string;
   direccionLineaAdicional: string;
   ciudad: string;
   giro: string;
   direccionEstadoRegion: string;
   paisId: number;
   codigoPais: number;
   activo: boolean;
   codigoInterno: number;
}
